import "./TestBadge.scss";

// Etichetta PROVA: allarmi e notifiche nati da una prova lanciata in Setup
const TestBadge = (props: { title?: string }) => {
  return (
    <span
      className="test-badge"
      title={props.title ?? "Allarme di prova lanciato da Setup"}
    >
      PROVA
    </span>
  );
};

export default TestBadge;
